import i18n from './i18n'

export const oidcSettings = {
  authority: `${process.env.VUE_APP_AUTH_SERVER_URL}/realms/${process.env.VUE_APP_AUTH_REALM_NAME}`,
  client_id: process.env.VUE_APP_CLIENT_ID,
  client_secret: process.env.VUE_APP_CLIENT_SECRET,
  client_authentication: 'client_secret_basic',
  redirect_uri: `${process.env.VUE_APP_PROTOCOL}://${process.env.VUE_APP_DOMAIN}/oidc-callback`,
  post_logout_redirect_uri: `${process.env.VUE_APP_PROTOCOL}://${process.env.VUE_APP_DOMAIN}`,
  response_type: 'code',
  scope: 'openid',
  automaticSilentRenew: false,
  automaticSilentSignin: true,
  extraQueryParams: {
    // '_locale': process.env.VUE_APP_I18N_LOCALE
    'ui_locales': i18n.global.locale.value
  }
}